import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '../services/api';

/**
 * AuthCallback Component
 * Handles the Google OAuth callback by processing the session_id from URL fragment.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing Google OAuth session...');

        // Call backend to process the session
        const response = await api.post('/api/auth/google/session', {
          session_id: sessionId
        });

        if (response.data.success && response.data.user) {
          console.log('Google OAuth successful:', response.data.user.email);
          
          // Store user info in localStorage for quick access
          localStorage.setItem('google_user', JSON.stringify(response.data.user));
          
          // Navigate to student dashboard with user data
          navigate('/student', { 
            replace: true,
            state: { user: response.data.user }
          });
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Google OAuth error:', error);
        navigate('/login', { 
          replace: true,
          state: { error: 'Google login failed. Please try again.' }
        });
      }
    };

    processSession();
  }, [navigate, location.hash]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-emerald-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-teal-600 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-700 mb-2">جاري تسجيل الدخول...</h2>
        <p className="text-gray-500">Signing you in with Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
